import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarLibroAuxiliarParams, BuscarLibroAuxiliarResponse, defaultBuscarLibroAuxiliarResponse, DescargarInformacionParams, GuardarObservaciones } from '../../interfaces/libros-electronicos/LibroAuxiliarInterfce';

export const ObtenerLibroAuxiliar = ( params: BuscarLibroAuxiliarParams ) => {

    return new Promise<BuscarLibroAuxiliarResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/LibroAuxiliar/ObtenerLibroAuxiliar', params, token)
            .then(({ data }: { data: BuscarLibroAuxiliarResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve({ ...defaultBuscarLibroAuxiliarResponse });
            });

        }

    });

}

export const GuardarObservacionesLibroAuxiliar = ( params: GuardarObservaciones ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/LibroAuxiliar/GuardarObservaciones', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const DescargarLibroAuxiliar = ( params: DescargarInformacionParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/LibroAuxiliar/DescargarInformacion', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
